import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Box, Container, SimpleGrid, Heading, Divider } from "@chakra-ui/react"
import TechnologyItem from "./TechnologyItem"

export function Technology() {
  const { dataJson } = useStaticQuery(graphql`
    {
      dataJson {
        technology {
          title
          copy
          image {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)

  const { technology } = dataJson

  return (
    <Box id="technology" as="section">
      <Divider as={Container} />

      <Container>
        <Heading size="3xl" textAlign="center" mb={2} fontWeight="semibold">
          Our Technology
        </Heading>
        <Heading
          color="primary.200"
          fontWeight="medium"
          textAlign="center"
          fontSize="lg"
          mb={8}
        >
          Our use of the latest technology and techniques ensures there is
          always a solution to your needs
        </Heading>

        <SimpleGrid
          spacing={{ base: 12, lg: 8 }}
          columns={{ base: 1, xl: 2 }}
          alignItems="center"
        >
          {technology.map(({ title, copy, image }, index) => {
            return (
              <TechnologyItem
                key={index}
                title={title}
                copy={copy}
                image={image}
              />
            )
          })}
        </SimpleGrid>
      </Container>
    </Box>
  )
}
